const home_page = {
  cardLimit: 8,
  sections: [
    {
      id: 1,
      key: "owned_stock",
      show: true,
      title: "CarsInfinite",
      highlight: "Owned Stock",
      type: "cars",
      filter: { is_modify: 0, is_project: 0 },
    },
    {
      id: 2,
      key: "modified_cars",
      show: true,
      title: "Premium",
      highlight: "Modified Cars",
      type: "cars",
      filter: { is_modify: 1, is_project: 0 },
    },
  ],
};

export default home_page;
